import { queryKeys } from '@query/keys'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

import { useAccountReadContext } from '@context/AccountContextContext'
import { useSessionLanguage } from '@context/SessionSettingsContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { LoyaltyDashboardDetailsDto } from '@model/IntroducingBrokerLoyalty'

interface UseIBLoyaltyValue {
  data: LoyaltyDashboardDetailsDto | null
  isLoading: boolean
  forceRefresh: (skipLoadingFlag?: boolean) => void
}

export const useIBLoyalty = (): UseIBLoyaltyValue => {
  const apiClient = useApiClient(ClientApiClient)
  const queryClient = useQueryClient()
  const { account } = useAccountReadContext()
  const locale = useSessionLanguage()

  const ibId = account?.clientIntroducingBroker?.id

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.ib.loyalty(ibId, locale),
    queryFn: () =>
      apiClient.getIBLoyalty({
        id: ibId!,
        languageId: locale,
      }),
    enabled: !!ibId,
  })

  const forceRefresh = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: queryKeys.ib.loyalty(ibId, locale),
    })
  }, [queryClient, ibId, locale])

  return {
    data: data || null,
    isLoading,
    forceRefresh,
  }
}
